module.exports = __webpack_public_path__ + "assets/img/registry.0b20f785.svg";